import React, { useEffect, useState } from 'react';

// Router-Dom
import { useHistory } from 'react-router-dom';

// Redux
import { useSelector } from 'react-redux';

// Material
import Box from '@material-ui/core/Box';
import { Typography } from '@material-ui/core';

// Constant
import PATH from 'constants/basePath';
import IMAGES from 'constants/images';
import AUTH from 'constants/auth';

// Helps
import { getOldModule, getUserType } from 'helpers/auth';
import { getStorageWebUserData } from 'helpers/webUser';

// types
import { ApplicationState } from 'store';

interface HasPermissionsProps {
  component: any;
  id?: string;
  currentModule?: string;
  externalModule?: string;
}
type Props = HasPermissionsProps;

const HasPermission: React.FC<Props> = ({
  component,
  currentModule = '',
  externalModule,
  id,
}) => {
  const history = useHistory();

  const [user, setUser] = useState<any>({});

  const webUserData = JSON.parse(getStorageWebUserData());

  const currentModuleData = useSelector(
    (state: ApplicationState) =>
      externalModule || state.currentModule.currentModuleData,
  );
  const userData = useSelector(
    (state: ApplicationState) => state.users.firebaseData,
  );
  const transportOperatorSelected = useSelector(
    (state: ApplicationState) =>
      state.transportOperators.transportOperatorSelected,
  );
  let filterLevel: any = {};
  let filterModule: any = true;
  let filterCurrentModule: any = true;

  try {
    if (user.levels) {
      filterLevel = JSON.parse(user.levels)?.find(
        (item: any) =>
          item.module === currentModuleData ||
          item.module === getOldModule(currentModuleData),
      );
    }

    if (user.modules) {
      filterModule = JSON.parse(user.modules)?.find(
        (item: any) =>
          item === currentModuleData ||
          item === getOldModule(currentModuleData),
      );

      if (currentModule) {
        filterCurrentModule = JSON.parse(user.modules)?.find(
          (item: any) =>
            item === currentModule || item === getOldModule(currentModule),
        );
      }
    }
  } catch (e) {
    // Do nothing
  }

  let hasPermission = true;
  if (filterLevel?.type === 'READ' || !filterModule || !filterCurrentModule) {
    hasPermission = false;
  }

  if (
    history.location.pathname === PATH.COMPANY_MANAGEMENT.BASE_URL &&
    !hasPermission
  ) {
    history.replace(PATH.NOT_ALLOWED.BASE_URL, {
      fromPath: history.location.pathname,
    });
  }

  useEffect(() => {
    if (webUserData) {
      if (
        transportOperatorSelected?.SupervisorOperator &&
        webUserData.id === userData.uid &&
        getUserType() === 'SUPERVISOR'
      ) {
        setUser(transportOperatorSelected?.SupervisorOperator);
      }
    }
  }, []);

  if (hasPermission) {
    return component;
  }

  if (currentModule) {
    let moduleLabel = '';
    for (const group of AUTH.MODULOS_MANEGEMENT) {
      const module = group.modules.find((m) => m.oldKey === currentModule);
      if (module) {
        moduleLabel = module.value;
        break;
      }
    }

    return (
      <Box
        margin={8}
        style={{
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
        {moduleLabel && (
          <Typography
            variant='h6'
            align='center'
            style={{ marginBottom: '16px' }}>
            O usuário não possui permissão para acessar o módulo ({moduleLabel}
            ).
          </Typography>
        )}
        <img src={IMAGES.BACKGROUND_IMAGES.PAGE_403} alt=' img 403' />
      </Box>
    );
  }

  return <></>;
};

export { HasPermission };
export default HasPermission;
